module.exports = __webpack_public_path__ + "img/GoblinMale_Light.567735e3.png";